import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { getObjectByValue } from '../../../utils/objects'

import LocalStorageService from '../../../services/LocalStorageService'
import NotificationService from '../../../services/NotificationService'
import UserService from '../../../services/UserService'

// Appt Components
import Box from '../../../components/simple/box/Box'
import Divider from '../../../components/simple/divider/Divider'
import Form from '../../../components/simple/form/Form'
import FormField from '../../../components/simple/formField/FormField'
import Select from '../../../components/simple/input/Select'
import H4 from '../../../components/simple/heading/H4.js'
import Text from '../../../components/simple/text/Text'
import ActionButton from '../../../components/compound/actionButton/ActionButton.js'

function Access (props) {
  const navigate = useNavigate()

  // List of staff
  const [staff, setStaff] = useState([])
  // Selected staff id
  const [accessValues, setAccessValues] = useState()
  // List of staff with access
  const [grantedStaff, setGrantedStaff] = useState([])
  // Enable/disable Grant Access button
  const [grantAccessAddButton, setGrantAccessAddButton] = useState(false)

  const apiToken = LocalStorageService.get('apiToken')
  const activeOrg = LocalStorageService.get('activeOrg')

  const params = useParams()

  const userId = params.userid

  const grantAccess = async (values) => {
    const toSend = {
      data: [
        {
          userGrantedAccess: values.id
        }
      ],
      // temporary bodge
      organisation: activeOrg.id
    }

    const accessGranted = await UserService.grantDirectAccess(apiToken, toSend, userId)

    if (accessGranted?.error) {
      NotificationService.error(accessGranted.error)
      return false
    } else {
      return true
    }
  }

  // Add staff member to granted access
  const addGrantAccess = async () => {
    // accessValues.staff has the id of the staff member
    // so get the name from the staff list

    const staffObject = getObjectByValue(staff, 'id', accessValues.staff)

    if (await grantAccess(staffObject)) {
      setGrantedStaff(granted => [...granted, staffObject])

      // Remove granted staff from list
      const newStaff = staff.filter((staff) => { return staff.id !== parseInt(staffObject.id) })
      setStaff(newStaff)

      // Clear Select box
      setAccessValues(values => ({
        ...values,
        staff: ''
      }))

      setGrantAccessAddButton(false)
    }
  }

  const revokeAccess = async (revokeId) => {
    const toSend = {
      data: [
        {
          userGrantedAccess: revokeId
        }
      ],
      // temporary bodge
      organisation: activeOrg.id
    }

    const accessRevoked = await UserService.revokeDirectAccess(apiToken, toSend, userId)

    if (accessRevoked?.error) {
      NotificationService.error(accessRevoked.error)
      return false
    } else {
      return true
    }
  }

  // Remove access for staff member
  const removeGrantAccess = async (memberIndex) => {
    if (await revokeAccess(memberIndex)) {
      // Add staff member back in list
      const staffToAdd = grantedStaff.filter((item) => item.id === memberIndex)
      // staffToAdd = staffToAdd[0]

      setStaff(previousValues => [
        ...previousValues,
        staffToAdd[0]
      ])

      // And remove from granted list
      const newGrants = grantedStaff.filter((item) => item.id !== memberIndex)

      setGrantedStaff(newGrants)
    }
  }

  const goBack = () => {
    navigate(-1)
  }

  useEffect(() => {
    let unmounted = false

    // Get all Staff with direct access to this user
    const getDirectAccess = async () => {
      const params = {
        fields: 'id,firstName,lastName,email',
        limit: 1000
      }

      const directAccessGrants = await UserService.getDirectAccessGrants(apiToken, userId, params)
      if (!directAccessGrants.error) {
        if (!unmounted) {
          const grantedStaff = directAccessGrants.data.map((data, index) => ({
            id: data.id,
            name: data.firstName + ' ' + data.lastName
          }))

          setGrantedStaff(grantedStaff)
        }
      }
    }

    getDirectAccess()

    return () => { unmounted = true }
  }, [])

  useEffect(() => {
    // Get all Staff for this Org
    const getStaff = async () => {
      const params = {
        fields: 'id,firstName,lastName,email',
        limit: 1000,
        showFormerStudents: 'false',
        type: 'user'
      }

      const staff = await UserService.getUsers(apiToken, params)
      if (!staff.error) {
        let mappedStaff = staff.data.map((data, index) => ({
          id: data.id,
          name: data.firstName + ' ' + data.lastName
        }))

        mappedStaff = mappedStaff.sort((a, b) => a.name.localeCompare(b.name))

        // Remove staff member being edited from the list
        mappedStaff = mappedStaff.filter((staff) => { return staff.id !== parseInt(userId) })

        // Remove granted staff from list
        grantedStaff.forEach(element => {
          mappedStaff = mappedStaff.filter((staff) => { return staff.id !== parseInt(element.id) })
        })

        setStaff(mappedStaff)
      }
    }

    getStaff()
  }, [grantedStaff])

  return (
    <Box gridArea='main' background='white' direction='column' gap='small' round='small'>
      <Divider color='primary' />
      <Box
        gap='small'
        round='small'
      >
        <>
          <Form
            //   validate='blur'
            onChange={nextValue => {
              if (nextValue.staff) {
                setGrantAccessAddButton(true)
              }
              setAccessValues(nextValue)
            }}
            // onSubmit={({ value: nextValue }) => {
            //   submitForm(nextValue)
            // }}
            value={accessValues}
          >
            <Box direction='row-responsive' justify='between' alignSelf='flex-start'>
              <Box direction='column' pad={{ horizontal: 'small', vertical: 'small' }} margin={{ horizontal: 'small' }}>

                  <H4 color='secondary' margin={{ top: 'none', bottom: 'small' }}>System Users With Access</H4>
                  

                {grantedStaff.length > 0
                  ? (
                    grantedStaff.map((staff) => {
                      return (
                        <Text alignSelf='start' textAlign='start' margin={{ bottom: 'small' }}>
                          {staff.name}
                          <ActionButton size='xsmall' pad='xxsmall' plain labelIcon={['fal', 'minus-circle']} margin={{ horizontal: 'xsmall' }}  onClick={() => removeGrantAccess(staff.id)} target='_self' />
                        </Text>
                      )
                    })
                  )
                  : <Text>No granted staff yet</Text>}
              </Box>

              <Box direction='column' alignItems='start'>
                <FormField
                  label='Grant access to a staff member'
                  name='staff'
                  required
                  alignSelf='start'
                >
                  <Select
                    id='staff'
                    name='staff'
                    labelKey='name'
                    //   onChange={({ option }) => changeOrganisation(option)}
                    options={staff}
                    valueKey={{ key: 'id', reduce: true }}
                  />
                </FormField>

                <ActionButton disabled={!grantAccessAddButton} labelIcon={['fal', 'plus-circle']} label='Grant Access' onClick={() => addGrantAccess()} />
              </Box>
            </Box>

          </Form>
        </>
      </Box>
    </Box>
  )
}

export default Access
